"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function HeroBanner() {
  const router = useRouter();
  const [busca, setBusca] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const searchTerm = busca.trim();
    if (searchTerm) {
      router.push(`/vagas?busca=${encodeURIComponent(searchTerm)}`);
    } else {
      router.push("/vagas");
    }
  };

  return (
    <section className="relative bg-blue-main min-h-[780px] lg:min-h-[700px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <Image
          src="/images/home/hero-background.png"
          alt=""
          fill
          className="object-cover hidden md:block"
          priority
        />
        <Image
          src="/images/home/hero-background-mobile.png"
          alt=""
          fill
          className="object-cover block md:hidden"
          priority
        />
      </div>

      <div className="container-default relative z-10 py-10 md:py-24 flex flex-col justify-start md:justify-center min-h-[600px] lg:min-h-[700px]">
        {/* Logo */}
        <div className="mb-4 mt-12 lg:mb-6">
          <Image
            src="/images/home/logo-hero.svg"
            alt="Muda pro Agibank"
            width={400}
            height={200}
            className="w-[280px] lg:w-[400px] h-auto"
            priority
          />
        </div>

        {/* Tagline */}
        <p className="text-white text-xl lg:text-4xl font-semibold mb-8 lg:mb-10">
          Vem crescer com a gente!
        </p>

        {/* Search field */}
        <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3 w-full max-w-xl">
          <div className="relative flex-1">
            <svg
              className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
            <input
              type="text"
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              placeholder="Busque por vagas ou palavras-chave"
              className="w-full pl-12 pr-4 py-4 rounded-lg text-base bg-white text-text-primary placeholder:text-text-secondary focus:outline-none focus:ring-2 focus:ring-secondary-main"
            />
          </div>
          <button
            type="submit"
            className="px-6 py-4 bg-secondary-main text-blue-dark font-semibold rounded-lg hover:bg-blue-dark hover:text-secondary-main cursor-pointer transition-colors whitespace-nowrap"
          >
            Buscar vagas
          </button>
        </form>
      </div>
    </section>
  );
}
